module.exports = __webpack_public_path__ + "static/intro.en-04044fa1835798be7132dd5971c6f254.svg";